module.exports = __webpack_public_path__ + "img/right-icon.516b3db4.png";